import { lazy } from 'react';

export const OnboardingPageLazy = lazy(() => import('./onboarding-page'));
